import React from 'react';
import ReactDOM from 'react-dom/client';
import GarageBrain from './app.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GarageBrain />
  </React.StrictMode>
);
